module.exports = __webpack_public_path__ + "img/About_one.f1c2cdfd.png";